import { ListItemIcon, ListItemText, Menu, MenuItem, MenuList } from "@mui/material";
import { getColumnsIcon, getColumnsIconColor } from "../automations-helper";

type ColumnItem = { id: string; type: string; name: string };

type PickerColumnProps = {
    anchorEl: HTMLElement | null;
    handleClose: () => void;
    filteredColumns: ColumnItem[];
    handleColumnChange: (id: string, name: string, type?: string) => void;
};

const PickerColumn = ({ anchorEl, handleClose, filteredColumns, handleColumnChange }: PickerColumnProps) => {
    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            <MenuList>
                {filteredColumns.map(({ id, type, name }) => (
                    <MenuItem key={id} onClick={() => handleColumnChange(id, name, type)} >
                        <ListItemIcon sx={{ display: 'flex', alignItems: "center", justifyContent: "center", minWidth: '25px', borderRadius: "4px", height: "22px", marginRight: "5px", backgroundColor: getColumnsIconColor(type) }}>{getColumnsIcon(type)}</ListItemIcon>
                        <ListItemText>{name}</ListItemText>
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};

export default PickerColumn;